import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Startups from '../views/Startups.vue'
import StartupDetails from '../views/StartupDetails.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/startups',
    name: 'Startups',
    component: Startups
  },
  {
    path: '/startups/:id',
    name: 'StartupDetails',
    props: true,
    component: StartupDetails
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
